import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}
import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require("pixi-spine");

import {gsap} from "gsap";
import {CustomEase} from "gsap/dist/CustomEase";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
gsap.registerPlugin(CustomEase, CustomWiggle);


import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {KeypadButtonIDs, SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {FlightMode} from "./game/FlightMode";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {FlightModeIntroConfig} from "./game/misc/FlightModeIntroConfig";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {FlightModePromoPanelConfig} from "./game/misc/FlightModePromoPanelConfig";

declare global {
    interface Window {
        NolimitLauncher:NolimitLauncher;
    }
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new FlightMode(),
    new SlotKeypad({playKeypadButtonSound(id: KeypadButtonIDs | string): boolean {
            if (id == "nolimitBonusMenu") {
                FlightMode.soundPlayer.playSound("xBetOnOff");
                return false;
            } else {
                return true;
            }
        }}),
    new NolimitGameIntroPlugin(new FlightModeIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new FlightModePromoPanelConfig())
]);
